// noinspection JSCheckFunctionSignatures

require('jquery');

const { FormStorage } = require("../app/FormStorage");

jQuery.fn.extend({
	scrollTo: function(element, duration, easing, complete, offset)
	{
		let self = $(this);
		let top = (typeof element != 'number' ? $(element).offset().top : element) + (offset || 0);
		self.animate({ scrollTop: top }, duration || 250, easing || 'swing', complete);
		return self;
	},

	addClassIf: function(classes, condition)
	{
		let self = $(this);
		if (condition)
			self.addClass(classes);
		else
			self.removeClass(classes);
		return self;
	},

	allInputs: function()
	{
		return $(this).find('input,select,textarea');
	},

	restoreFromStorage: function()
	{
		return $(this).each(function()
		{
			FormStorage.restore(this);
		});
	},

	enableStorage: function()
	{
		return $(this).each(function()
		{
			FormStorage.storeFieldOnChanges(this);
		});
	},

	enableWhenChecked: function(selector)
	{
		let selected = $(selector);
		return $(this).on('change', function()
		{
			if (this.checked)
				selected.removeAttr('disabled');
			else
				selected.attr('disabled', 'disabled');
		});
	},

	disableWhenChecked: function(selector)
	{
		let selected = $(selector);
		return $(this).on('change', function()
		{
			if (!this.checked)
				selected.removeAttr('disabled');
			else
				selected.attr('disabled', 'disabled');
		});
	},
});

$(() =>
{
	$('[data-enabled-by]').each(function()
	{
		$(this.dataset.enabledBy).enableWhenChecked(this);
	});
});
